<script setup>
// imports
import {computed, reactive, ref, toRefs} from "vue";
import AppCountInput from "./AppCountInput.vue";
import {modalStore} from "../stores/ModalStore";

// props
const props = defineProps({
    articleSet: Object,
    category: String
});

// emits
defineEmits(["addToCart"])
//defineEmits(["addToWishlist"])

// data
const count = ref(0);
const articleSetImage = props.articleSet.articlesetimage ?
    "/images/" + props.articleSet.articlesetimage.imagedir + props.articleSet.articlesetimage.image + "?w=896&h=433&fit=crop"
    : "/img/no-picture-set.jpg";


const imageSource = reactive({path: articleSetImage});

function showActionSetImage() {
    if (props.articleSet.actionsetimage) {
        imageSource.path = "/images/" + props.articleSet.actionsetimage.imagedir
            + props.articleSet.actionsetimage.image + "?w=896&h=433&fit=crop";
    }
}

function openModal() {
    history.pushState(null, null, '/articlesets/' + props.articleSet.slug);
    modalStore.setIsOpened(true);
    modalStore.setArticle(null);
    modalStore.setArticleSet(props.articleSet);
    modalStore.setCategory(props.category);
}

function showArticleSetImage() {
    imageSource.path = articleSetImage;
}

function showDiscount() {
    if (
        articleSet.discount = articleSet.discount.toFixed()
    ) {
        let discount = articleSet.discount.toFixed()
    } else {
        let discount = articleSet.discount.toFixed(2)
    }
    return discount;
}

</script>
<template>
    <div class="col-12 col-md-6 pe-3 ps-3 mb-4">
        <div class="card">
            <div class="articleset-name">
                {{ articleSet.name }}
            </div>
            <div class="position-relative">
                <img
                    :src="imageSource.path"
                    width="896"
                    height="433"
                    class="img-fluid position-relative"
                    loading="lazy"
                    @mouseover="showActionSetImage"
                    @mouseout="showArticleSetImage"
                    @click="openModal()"
                />
                <div v-if="articleSet.badge" class="article-badge">
                    <img v-if="articleSet.badge === 'new'" :src="'/img/new_product.svg'" alt="NEW Product"
                         class="img-fluid"/>
                    <img v-else-if="articleSet.badge === 'top'" :src="'/img/top_seller.svg'" alt="TOP Seller"
                         class="img-fluid"/>
                </div>
                <div v-if="articleSet.supplier?.badge" class="supplier-badge">
                    <img :src="'/img/' + articleSet.supplier?.badgedir + articleSet.supplier.badge"
                         :alt="articleSet.supplier.name"
                         class="img-fluid"/>
                </div>
            </div>
            <div class="row pt-1 ">
                <div class="small col-12 col-md-5">
                     <span v-if="articleSet.discount > 0" class="discount-red">{{
                             articleSet.rentalprice_discounted
                         }} CHF / {{ Number(articleSet.discount).toFixed(2) }}%<br>
                    <s>{{ articleSet.price }} CHF</s></span>
                    <strong v-else>{{ articleSet.price }} CHF</strong>
                </div>
                <div class="col-12 col-md-7 text-end">
                    <AppCountInput v-model="count"/>
                    <svg class="bi flex-shrink-0 ms-2 me-1" width="18" height="18" role="button"
                         aria-label="Warenkorb" title="zum Warenkorb hinzufügen"
                         @click="$emit('addToCart', count), (count = 0)">
                        <use xlink:href="#icon-basket"/>
                    </svg>
                    <!--                    <svg class="bi flex-shrink-0 me-1" width="18" height="18" role="button"
                                             aria-label="Wunschliste">
                                            <use xlink:href="#icon-wishlist"/>
                                        </svg>-->
                </div>
            </div>
        </div>
    </div>

</template>
<style scoped>
img {
    cursor: pointer;
}
</style>

